import { useEffect, useState } from 'react';

// use to avoid hydration error
export const useClientRenderDelay = () => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    setTimeout(() => {
      setReady(true);
    }, 250);
  }, []);

  return ready;
};
